export default __webpack_public_path__ + "static/9-ways-to-survive-japan-knowing-only-english-hero-image-f4c3c64f6e439104d0fe510e4c2ad26d.jpg";